import { createSlice } from '@reduxjs/toolkit';

export const callQueueSlice = createSlice({
  name: 'callQueue',
  initialState: {
    queues: [],
  },
  reducers: {
    setCallQueues: (state, action) => {
      state.queues = action.payload;
    },
  },
});

export const { setCallQueues } = callQueueSlice.actions;
export const selectCallQueues = (state) => state.callQueue.queues;

export default callQueueSlice.reducer;
